module.exports = __webpack_public_path__ + "static/img/logo.35e85b49.png";